import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
export const TENANTNAME = "riskwell/tenantcreation/TENANTNAME";
export const TENANTKEY = "riskwell/tenantcreation/TENANTKEY";
export const TENANTMOBILE = "riskwell/tenantcreation/TENANTMOBILE";
export const TENANATTELEPHONE = "riskwell/tenantcreation/TENANATTELEPHONE";
export const TENANTEMAIL = "riskwell/tenantcreation/TENANTEMAIL";
export const TENANTUSERLIMITS = "riskwell/tenantcreation/TENANTUSERLIMITS";
export const TENANTDESC = "riskwell/tenantcreation/TENANTDESC";
export const TENANTSERVICEPLAN = "riskwell/tenantcreation/TENANTSERVICEPLAN";
export const ADDRESSLINE1 = "riskwell/tenantcreation/ADDRESSLINE1";
export const ADDRESSLINE2 = "riskwell/tenantcreation/ADDRESSLINE2";
export const TENANTCOUNTRY = "riskwell/tenantcreation/TENANTCOUNTRY";
export const TENANTSTATE = "riskwell/tenantcreation/TENANTSTATE";
export const TENANTCITY = "riskwell/tenantcreation/TENANTCITY";
export const TENANTPOSTALCODE = "riskwell/tenantcreation/TENANTPOSTALCODE";
export const TENANTLOGO = "riskwell/tenantcreation/TENANTLOGO";
export const TENANTCREATIONSUCCESS =
  "riskwell/tenantcreation/TENANTCREATIONSUCCESS";
export const TENANTCREATIONFAILURE =
  "riskwell/tenantcreation/TENANTCREATIONFAILURE";
export const RESETDATA = "riskwell/tenantaction/RESETDATA";
export const LOGGEDINLOADER = "riskwell/tenantaction/LOGGEDINLOADER";
export const TENANTFALIURE = "riskwell/tenantaction/TENANTFALIURE";
export const ACTIVATIONDATE = "riskwell/tenantcreation/ACTIVATIONDATE";
export const TENANTRENEWALDATE = "riskwell/tenantcreation/TENANTRENEWALDATE";
export const TENANTVALIDDATE = "riskwell/tenantcreation/TENANTVALIDDATE";
export const PRIMESUBSCRIPTION = "riskwell/tenantcreation/PRIMESUBSCRIPTION";
export const TENANTMATRIX = "riskwell/tenantcreation/TENANTMATRIX";
export const ISTASKMODULEENABLED  = "riskwell/tenantcreation/ISTASKMODULEENABLED";



export const tenantName = (Data) => {
  return {
    type: TENANTNAME,
    payload: Data,
  };
};

export const tenantKey = (key) => {
  return {
    type: TENANTKEY,
    payload: key,
  };
};

export const tenantMobile = (num) => {
  return {
    type: TENANTMOBILE,
    payload: num,
  };
};

export const tenantTelephone = (num) => {
  return {
    type: TENANATTELEPHONE,
    payload: num,
  };
};

export const tenantEmail = (email) => {
  return {
    type: TENANTEMAIL,
    payload: email,
  };
};

export const tenantUserLimits = (limit) => {
  return {
    type: TENANTUSERLIMITS,
    payload: limit,
  };
};

export const tenantDesc = (des) => {
  return {
    type: TENANTDESC,
    payload: des,
  };
};

export const tenantServicePlan = (plan) => {
  return {
    type: TENANTSERVICEPLAN,
    payload: plan,
  };
};

export const addressLine1 = (add) => {
  return {
    type: ADDRESSLINE1,
    payload: add,
  };
};

export const addressLine2 = (add) => {
  return {
    type: ADDRESSLINE2,
    payload: add,
  };
};

export const tenantCountry = (country) => {
  return {
    type: TENANTCOUNTRY,
    payload: country,
  };
};
export const tenantState = (state) => {
  return {
    type: TENANTSTATE,
    payload: state,
  };
};
export const tenantCity = (city) => {
  return {
    type: TENANTCITY,
    payload: city,
  };
};

export const tenantPostalCode = (postalcode) => {
  return {
    type: TENANTPOSTALCODE,
    payload: postalcode,
  };
};

export const tenantLogo = (logo) => {
  return {
    type: TENANTLOGO,
    payload: logo,
  };
};

export const activationDate = (tenantActivationDate) => {
  return {
    type: ACTIVATIONDATE,
    payload: tenantActivationDate,
  };
};
export const tenantRenewalDate = (renewalDate) => {
  return {
    type: TENANTRENEWALDATE,
    payload: renewalDate,
  };
};
export const tenantValidDate = (validDate) => {
  return {
    type: TENANTVALIDDATE,
    payload: validDate,
  };
};
export const primeSubscription = (subscription) => {
  return {
    type: PRIMESUBSCRIPTION,
    payload: subscription,
  };
};
export const handleTasksModuleEnabled = (subscription) => {
  return {
    type: ISTASKMODULEENABLED,
    payload: subscription,
  };
};
export const tenantMatrix = (matrix) => {
  return {
    type: TENANTMATRIX,
    payload: matrix,
  };
};
export const TenantStatus = (success) => {
  return {
    type: TENANTCREATIONSUCCESS,
    payload: success,
  };
};

export const TenantLogo = (img) => {
  return {
    type: TENANTLOGO,
    payload: img,
  };
};

export const TenantFailureStatus = (message) => {
  return {
    type: TENANTCREATIONFAILURE,
    payload: message,
  };
};

export const ResetData = () => {
  return {
    type: RESETDATA,
  };
};

export const loggedInLoader = (bool) => {
  return {
    type: LOGGEDINLOADER,
    payload: bool,
  };
};

export const TenantFailure = (err) => {
  return {
    type: TENANTFALIURE,
    payload: err,
  };
};

export const TenantCreation = (params) => async (dispatch) => {
  try {
      console.log(params);
    dispatch(loggedInLoader(true));
    let result = params.TenantId
      ? await Api.updateTenant(params)
      : await Api.addTenant(params);
    dispatch(loggedInLoader(false));
    if (result.status === 200) {
      dispatch(ResetData());
      dispatch(TenantStatus(result.message));
      toastr.success(result && result.message);
    }
    else {
      toastr.error(result.message);
      dispatch(TenantFailureStatus(result.message));
    }
  } catch (error) {
    dispatch(loggedInLoader(false));
    toastr.error("Error in Tenant Creation");
    dispatch(TenantFailureStatus("Error in Tenant Creation"));
  }
};
